import { injectable, injectFromBase } from 'inversify'
import { RepoSettings } from '@/decorators/repositoryDecorators'
import type { Endpoint } from '@/services/endpoints'
import OrmApiRepository from '@/data/repositories/ormApiRepository'
import TollFreeBrand from '@/data/models/domain/services/regulations/TollFreeBrand'

@RepoSettings<Endpoint>({
  model: TollFreeBrand,
})
@injectable()
@injectFromBase()
export default class TollFreeBrandRepository extends OrmApiRepository<TollFreeBrand> {}
